import { render } from "./jobAbout.vue?vue&type=template&id=b4be4f32&scoped=true"
import script from "./jobAbout.vue?vue&type=script&lang=js"
export * from "./jobAbout.vue?vue&type=script&lang=js"

import "./jobAbout.vue?vue&type=style&index=0&id=b4be4f32&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4be4f32"]])

export default __exports__